import { searchRegistry } from "../../platform/search/register/search-registry";
import { FileClock, FileUser, FolderClock } from "lucide-react";

searchRegistry.register([
    {
        id: "leaves.management",
        title: "Leave Summary",
        description: "View Leave Summary ",
        route: "/time-off/leaves/summary",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave", "summary"],
        icon: FileUser,
        priority: 1,
        type: 'quickLink'
    },
    {
        id: "leaves.management.entitlement",
        title: "Manage Leave Entitlement",
        description: "Manage Employee Leave Entitlements",
        route: "time-off/leaves/entitlement",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave", "entitlement", "leave allocation"],
        icon: FileUser,
        type: 'result'
    },
    {
        id: "leaves.management.approvals",
        title: "Leave Approvals",
        description: "Manage Employee Leaves",
        route: "time-off/leaves/approvals",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave", "summary"],
        icon: FileUser,
        type: 'result'
    },
    {
        id: "leaves.management.requests",
        title: "Manage Leave Requests",
        description: "Manage Employee Leaves",
        route: "/time-off/leaves/request",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["leave", "summary"],
        icon: FileUser,
        type: 'result'
    },
    {
        id: "leaves.summary",
        title: "Leave Summary",
        description: "View Leave Summary ",
        route: "/time-off/leaves/summary",
        category: "Employee-Administration",
        permissions: ["EMPLOYEE"],
        tags: ["leave", "summary"],
        icon: FileUser,
        type: 'quickLink'
    },
    {
        id: "leaves.management",
        title: "My Leave Requests",
        description: "Manage My Leaves Requests ",
        route: "/time-off/leaves/request",
        category: "Employee-Administration",
        permissions: ["EMPLOYEE"],
        tags: ["leave", "requests", "pending", "approved", "rejected"],
        icon: FileUser,
        type: 'result'
    },
    {
        id: "timeOff.holidays",
        title: "Holiday Calendar",
        description: "View Holidays",
        route: "/time-off/holidays",
        category: "Administration",
        permissions: ["EMPLOYEE","ADMIN","USER"],
        tags: ["holidays", "festival", "off"],
        icon: FileUser,
        type: 'result'
    }

]);
